'use client';

import dynamic from 'next/dynamic';
import { useAuth } from '@/contexts/AuthContext';
import { DashboardPage } from './dashboard-page';

const LoginScreen = dynamic(
  () => import('@/components/shared-assets/login/login-simple').then((mod) => ({ default: mod.LoginSimple })),
  { ssr: false },
);

export default function HomePage() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-primary">
        <div className="text-center">
          <p className="text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return <DashboardPage />;
}
